<template>
  <div class="company">
    <banner clazz="company-banner" url="company">
      <template slot="buttons">
<!--        <el-button class="banner-button" round @click="goRegister(1)">申请体验</el-button>-->
        <el-button class="banner-button" round @click="this.goConsult">立即咨询</el-button>
      </template>
    </banner>
    <div class="company-content">
      <div class="content-box">
        <div class="content-breadcrumb cp">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item><a href="/">首页</a></el-breadcrumb-item>
            <el-breadcrumb-item><span @click="GobackDetails">公司动态和市场活动</span></el-breadcrumb-item>
            <el-breadcrumb-item>{{breadcrumbTitle}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="content-center">
          <div class="content-title clearfix">
            <div class="title-one cp" v-for="item in titleCon" :key="item.id" :class="{ IsClick : clickTitle === item.id}" @click="clickType(item)" >
              <span>{{item.name}}</span>
            </div>
            <div style="float:right">
              <el-popover
                placement="bottom"
                popper-class="con-popover-hot"
                :visible-arrow="false"
                trigger="click">
                <div class="clearfix">
                  <div style="width:50%;float:left" class="cp" @click="hotClick(item.id)" v-for="item in hotTags">
                    <span>{{item.name}}</span>
                  </div>
                </div>
                <div class="title-three cp" slot="reference">
                  <span>热门标签</span>
                  <img src="../../assets/img/company/companyicon2.png" alt="热门标签"  style="margin-top: -3px;" />
                </div>
              </el-popover>
              <el-popover
                placement="bottom"
                popper-class="con-popover-date"
                :visible-arrow="false"
                trigger="click">
                <div>
                  <div v-for="item in companyDate" :key='item.id' class="cp" @click="dateClick(item.dateId)" >{{item.name}}</div>
                </div>
                <div class="title-two cp"  slot="reference">
                  <span>时间</span>
                  <img src="../../assets/img/company/companyicon2.png" alt="热门标签" style="margin-top: -3px;" />
                </div>
              </el-popover>
            </div>
          </div>
          <div  v-if="checkShow">
            <div v-show="checkData" class="content-dynamic clearfix">
              <a class="dynamic-div cp db" :href="checkDetails(item)" target="_blank"
                 v-for="(item,index) in newsData.news" :key="index" @mouseenter="dynamicEnter(index)" @mouseleave="dynamicLeave">
                <div class="dynamic-div-img" :style="{'backgroundImage': 'url(' + $global.globalPath + item.img + ')'}">
                  <div class="dynamic-describe-show"  :class="{IsDescribehover : dynamicHover == index ? true : false}">
                    <span>{{showOrigin(item.origin,index)}}</span>
                  </div>
                </div>
                <div class="dynamic-div-title clearfix">
                  <h1 class="dynamic-title-top">{{item.title}}</h1>
                  <div  class="dynamic-title-buttom">
                  <img src="../../assets/img/company/companyicon1.png" :alt="item.title" style="margin-right:10px" />
                  <span>{{item.year}}</span>
                  </div>
                </div>
              </a>
            </div>
            <div v-show="!checkData" class="content-nodata">
              <span>暂无数据</span>
            </div>
            <div class="dynamic-pagination" v-show="checkData">
              <el-pagination
                layout="prev, pager, next"
                class="pagination-cen"
                :page-size="6"
                @current-change="currentChange(currentPage)"
                :current-page.sync="currentPage"
                :pager-count="5"
                :total="newsData.count_list">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import banner from '../common/banner.vue'
export default {
  inject: ['openRegister', 'goConsult'],
  name: 'company',
  components: {
    banner
  },
  metaInfo () {
    return {
      title: this.$seo.company.title, // set a title
      meta: [{ // set meta
        name: 'keywords',
        content: this.$seo.company.keywords
      },
      {
        name: 'description',
        content: this.$seo.company.description
      }]
    }
  },
  data () {
    return {
      ellipsis: false,
      checkData: true,
      breadcrumbTitle: '公司动态',
      titleCon: [], // 分类数据源
      detailsCon: {},
      dynamicHover: -1, // 列表页是否hover
      checkShow: true,
      clickTitle: '6',
      currentPage: 1,
      newsData: this.$store.state.newsList || {},
      detailContent: '',
      diyCon: [],
      companyDate: [
        {
          dateId: 'all',
          name: '全部时间'
        },
        {
          dateId: 1,
          name: '一个月'
        },
        {
          dateId: 3,
          name: '三个月'
        },
        {
          dateId: 6,
          name: '半年'
        },
        {
          dateId: 12,
          name: '一年'
        }
      ],
      timeScope: 'all',
      tagid: '',
      hotTags: []
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.getTitleConDate()
    this.gitNewsListDate()
    this.getHotTagsData()
    next()
  },
  methods: {
    // goRegister (code) {
    //   this.openRegister(false, code)
    // },
    showOrigin (item, index) {
      if (this.dynamicHover === index) {
        if (item.length > 100) {
          return item.slice(0, 100) + '...'
        } else {
          return item
        }
      } else {
        if (item.length > 20) {
          return item.slice(0, 20) + '...'
        } else {
          return item
        }
      }
    },
    dynamicEnter (index) {
      this.dynamicHover = index
      this.ellipsis = true
    },
    dynamicLeave () {
      this.dynamicHover = -1
      this.ellipsis = false
    },
    hotClick (id) {
      this.tagid = id
      this.currentPage = 1
      this.timeScope = ''
      this.gitNewsListDate()
      this.checkShow = true
    },
    dateClick (id) {
      this.timeScope = id
      this.currentPage = 1
      this.tagid = ''
      this.gitNewsListDate()
      this.checkShow = true
    },
    checkDetails (item) {
      let routeUrl = this.$router.resolve({
        name: 'CompanyDetail',
        query: {
          id: item.id,
          cat_id: this.clickTitle
        }
      })
      let result = this.$global.frontPath + routeUrl.href
      return result
    },
    diyClick (id) {
      this.getDetailsDate(id)
    },
    GobackDetails () {
      this.clickTitle = this.titleCon[0].id
      this.breadcrumbTitle = this.titleCon[0].name
      this.gitNewsListDate()
    },
    clickType (item) {
      this.clickTitle = item.id
      this.breadcrumbTitle = item.name
      this.gitNewsListDate()
    },
    currentChange (currentPage) {
      this.currentPage = currentPage
      this.gitNewsListDate()
    },
    // 获取分类标题
    getTitleConDate () {
      this.$api.post('/news/news_types', '', (r) => {
        if (r.code === 0) {
          this.titleCon = r.data
        } else {
          this.$message.error(r.message)
        }
      })
    },
    // 获取新闻列表
    gitNewsListDate () {
      let a = {
        time_scope: this.timeScope,
        tagid: this.tagid,
        cat_id: this.clickTitle,
        counts: 6,
        page: this.currentPage
      }
      this.$api.post('/news/news_list', a, (r) => {
        if (r.code === 0) {
          if (r.data.news.length === 0) {
            this.checkData = false
          } else {
            this.newsData = r.data
            this.checkData = true
          }
        } else {
          this.$message.error(r.message)
        }
      })
    },
    // 获取详情页
    getDetailsDate (id) {
      let a = {
        new_id: id
      }
      this.$api.post('/news/new_details', a, (r) => {
        if (r.code === 0) {
          this.detailsCon = r.data
          this.detailContent = r.data.content
        } else {
          this.$message.error(r.message)
        }
      })
    },
    getDiyDate (id) {
      let a = {
        new_id: id
      }
      this.$api.post('/news/news_diy', a, (r) => {
        if (r.code === 0) {
          this.diyCon = r.data
        } else {
          this.$message.error(r.message)
        }
      })
    },
    getHotTagsData () {
      this.$api.post('/news/news_tags', '', (r) => {
        if (r.code === 0) {
          this.hotTags = r.data
        } else {
          this.$message.error(r.message)
        }
      })
    }
  },
  mounted () {
    this.getTitleConDate()
    if (!this.newsData.news.length) {
      this.gitNewsListDate()
    }
    this.getHotTagsData()
  }
}
</script>

<style lang="scss" >
  @import "../../../static/css/company.scss";
</style>



// WEBPACK FOOTER //
// company.vue?30a40953